export const FILTERLIST = [
  { text: '待到账', status: 1 },
  { text: '已到账', status: 2 },
  { text: '已失效', status: 3 }
]
